const backendUrl = process.env.REACT_APP_BACKEND_URL;

export const fetchSalesMasterData = async (seNo) => {
    try {
        const response = await fetch(`${backendUrl}/api/sales-master?se_no=${seNo}`, {
            method: 'GET',
            headers: { 'Content-Type': 'application/json' },
        });

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        return await response.json();
    } catch (error) {
        console.error('Error fetching sales master data:', error);
        throw error;
    }
};


export const getSalesMasterDataUtama = async () => {
    try {
        const response = await fetch(`${backendUrl}/api/sales-master-utama`);
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        const data = await response.json();
        return data;
    } catch (error) {
        console.error("Could not fetch sales data:", error);
        throw error;
    }
};


export const saveSalesMasterData = async (formData) => {
    try {
        const response = await fetch(`${backendUrl}/api/sales-master`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(formData)
        });

        if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
        return await response.json();
    } catch (error) {
        console.error('Error saving sales master data:', error);
        throw error;
    }
};

export const fetchSalesData = async () => {
    try {
        const response = await fetch(`${backendUrl}/sales-master`);
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        const data = await response.json();
        return data;
    } catch (error) {
        console.error("Could not fetch sales data:", error);
        throw error;
    }
};


export async function fetchDealerName() {
    try {
        const response = await fetch(`${backendUrl}/api/dealer_name`);
        if (!response.ok) throw new Error("Failed to fetch Dealer Name");
        return await response.json();
    } catch (error) {
        console.error("Error fetching Dealer Name:", error);
        return [];
    }
}

export async function fetchDeliverVia() {
    try {
        const response = await fetch(`${backendUrl}/api/deliver-via`);
        if (!response.ok) throw new Error("Failed to fetch Deliver Via");
        return await response.json();
    } catch (error) {
        console.error("Error fetching Deliver Via:", error);
        return [];
    }
}

export async function fetchOutstandingRemark() {
    try {
        const response = await fetch(`${backendUrl}/api/outstanding-remark`);
        if (!response.ok) throw new Error("Failed to fetch Outstanding Remark");
        return await response.json();
    } catch (error) {
        console.error("Error fetching Outstanding Remark:", error);
        return [];
    }
}

export async function fetchTop() {
    try {
        const response = await fetch(`${backendUrl}/api/top`);
        if (!response.ok) throw new Error("Failed to fetch TOP");
        return await response.json();
    } catch (error) {
        console.error("Error fetching TOP:", error);
        return [];
    }
}

export async function fetchOrderType() {
    try {
        const response = await fetch(`${backendUrl}/api/order-type`);
        if (!response.ok) throw new Error("Failed to fetch Order Type");
        return await response.json();
    } catch (error) {
        console.error("Error fetching Order Type:", error);
        return [];
    }
}

export async function fetchTransactionType() {
    try {
        const response = await fetch(`${backendUrl}/api/transaction-type`);
        if (!response.ok) throw new Error("Failed to fetch Transaction Type");
        return await response.json();
    } catch (error) {
        console.error("Error fetching Transaction Type:", error);
        return [];
    }
}

export async function fetchProvinsi() {
    try {
        const response = await fetch(`${backendUrl}/api/provinsi`);
        if (!response.ok) throw new Error("Failed to fetch Provinsi");
        return await response.json();
    } catch (error) {
        console.error("Error fetching Provinsi:", error);
        return [];
    }
}

export async function fetchKabupaten() {
    try {
        const response = await fetch(`${backendUrl}/api/kabupaten`);
        if (!response.ok) throw new Error("Failed to fetch Kabupaten");
        return await response.json();
    } catch (error) {
        console.error("Error fetching Kabupaten:", error);
        return [];
    }
}

export async function fetchKecamatan() {
    try {
        const response = await fetch(`${backendUrl}/api/kecamatan`);
        if (!response.ok) throw new Error("Failed to fetch Kecamatan");
        return await response.json();
    } catch (error) {
        console.error("Error fetching Kecamatan:", error);
        return [];
    }
}

export async function fetchKelurahan() {
    try {
        const response = await fetch(`${backendUrl}/api/kelurahan`);
        if (!response.ok) throw new Error("Failed to fetch Kelurahan");
        return await response.json();
    } catch (error) {
        console.error("Error fetching Kelurahan:", error);
        return [];
    }
}

export async function fetchGenerateNo() {
    try {
        const response = await fetch(`${backendUrl}/api/generate-no`);
        if (!response.ok) throw new Error("Failed to fetch Generate No");
        return await response.json();
    } catch (error) {
        console.error("Error fetching Generate No:", error);
        return [];
    }
}

export async function generateSENumber() {
    try {
        const response = await fetch(`${backendUrl}/api/generate-se-number`);
        if (!response.ok) throw new Error("Failed to generate SE number");
        return await response.json();
    } catch (error) {
        console.error("Error generating SE number:", error);
        return null;
    }
}

export const fetchPPN = async () => {
    try {
        const response = await fetch(`${backendUrl}/api/ppn`);
        if (!response.ok) throw new Error("Failed to fetch PPN");
        return await response.json();
    } catch (error) {
        console.error("Error fetching PPN:", error);
        throw error;
    }
};

export const fetchUserByKodeGrup1 = async (kode) => {
    try {
        const response = await fetch(`${backendUrl}/api/auth/user-by-kode-grup1/${kode}`, {
            headers: {
                'Authorization': `Bearer ${localStorage.getItem('authToken')}`
            }
        });
        if (!response.ok) throw new Error("Gagal mengambil data user");
        return await response.json();
    } catch (error) {
        console.error("Error fetching user:", error);
        return null;
    }
};

export const closeSalesOrder = async (seNo, reason, reasonLabel, requestBy) => {
    try {
        const response = await fetch(`${backendUrl}/api/close-order`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ se_no: seNo, close_order_reason: reason, reason_label: reasonLabel, request_by: requestBy })
        });
        if (!response.ok) throw new Error('Failed to close order');
        return await response.json();
    } catch (error) {
        console.error('Error closing order:', error);
        throw error;
    }
};
